import * as React from "react";
const SvgPaymentDetail = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M24 4.98c0 .792-.648 1.44-1.44 1.44H1.44C.648 6.42 0 5.772 0 4.98v-.012A4.963 4.963 0 0 1 4.968 0H19.02A4.983 4.983 0 0 1 24 4.98M0 9.662v6.012a4.963 4.963 0 0 0 4.968 4.968H19.02a4.983 4.983 0 0 0 4.98-4.98v-6c0-.792-.648-1.44-1.44-1.44H1.44C.648 8.222 0 8.87 0 9.662m7.2 6.96H4.8a.907.907 0 0 1-.9-.9c0-.492.408-.9.9-.9h2.4c.492 0 .9.408.9.9s-.408.9-.9.9m7.8 0h-4.8a.907.907 0 0 1-.9-.9c0-.492.408-.9.9-.9H15c.492 0 .9.408.9.9s-.408.9-.9.9"
    />
  </svg>
);
export default SvgPaymentDetail;
